import { IBaseListWebItem } from './../../../shared/components/base-list-web/base-list-web-item.model';
import { BaseListWebService } from './../../../shared/components/base-list-web/base-list-web.service';
import { Component, OnInit, Input } from '@angular/core';
import { BaseListWebComponent } from '@web/base/shared/components/base-list-web/base-list-web.component';
import { ConstantsProject } from '@web/project/shared/constants.class';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'web-home-list-content',
  templateUrl: './list-content.component.html',
  styleUrls: ['./list-content.component.scss'],
  providers: [BaseListWebService]
})
export class ListContentComponent extends BaseListWebComponent implements OnInit {
  @Input() content$: Observable<Array<IBaseListWebItem>>;

  public items$: Subject<Array<any>> = new Subject<Array<any>>();

  itemKeyName = 'elementID';

  public COVER_ELEMENT_TYPE_CONTENTS = ConstantsProject.COVER_ELEMENT_TYPE_CONTENTS;

  getData() {
    this.subscriptions.push(
      this.content$.subscribe(content => {
        this.items$.next(
          content.map(c => {
            const image = c.files.find(f => f.name === 'image');
            c.image = image?.url ? image.url : '../../../../../../assets/img/default.webp';
            c.categoryName = c.categoryName && c.categoryName !== 'Páginas estáticas' ? c.categoryName : 'cositalnetwork';

            return c;
          })
        );
      })
    );
  }

  publicPrivateLogin() {
    this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url } });
  }

}
